import React from 'react';

import Box from '~/common/components/Box';

const DrawerContent = ({
  children,
  ...props
}: Readonly<Pick<React.ComponentProps<typeof Box>, 'sx' | 'children'>>) => {
  return <Box {...props}>{children}</Box>;
};

export default DrawerContent;
